import { createHashHistory } from 'history';

export const hashHistory = createHashHistory();
